import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';
import {
  removeCustomGroup,
  hideDeleteCustomGroupModal,
} from './store/actions';
import { requiredWhenPresent } from '../../shared/propTypes';
import { isDeletingCustomGroupInProgressSelector } from './store/selectors';

class DeleteCustomGroupModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      customGroupId: PropTypes.number.isRequired,
      customGroupName: PropTypes.string.isRequired,
    })),
    isVisible: PropTypes.bool.isRequired,
    removeCustomGroup: PropTypes.func.isRequired,
    isDeletingInProgress: PropTypes.bool.isRequired,
  };

  deleteCustomGroup = () => {
    const { entityToRemove, removeCustomGroup } = this.props;

    removeCustomGroup({
      groupId: entityToRemove.customGroupId,
    });
  };

  render() {
    const {
      hideModal,
      entityToRemove,
      isVisible,
      isDeletingInProgress,
    } = this.props;

    return (
      <Modal
        className="delete-custom-group-modal"
        dismissText="Cancel"
        submitText="Yes"
        title="Delete Custom Group"
        closeAction={hideModal}
        dismissAction={hideModal}
        submitAction={this.deleteCustomGroup}
        isVisible={isVisible}
        isSubmitting={isDeletingInProgress}
      >
        {
          entityToRemove && (
            <span>Are you sure you want to delete: {entityToRemove.customGroupName}</span>
          )
        }
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingInProgress: isDeletingCustomGroupInProgressSelector(state),
});

export default connect(
  mapStateToProps,
  {
    removeCustomGroup,
    hideModal: hideDeleteCustomGroupModal,
  }
)(DeleteCustomGroupModal);
